import md5 from 'js-md5'

const encryptPassword = (str) => {
  var password = md5(str)
  return password.substring(8, 16) + password.substring(20, 32)
}

const md5Util={
  'encryptPassword':encryptPassword
}

export default md5Util